import { render, staticRenderFns } from "./AddGoodsModal.vue?vue&type=template&id=39db9a2d&scoped=true"
import script from "./AddGoodsModal.vue?vue&type=script&lang=js"
export * from "./AddGoodsModal.vue?vue&type=script&lang=js"
import style0 from "./AddGoodsModal.vue?vue&type=style&index=0&id=39db9a2d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39db9a2d",
  null
  
)

export default component.exports